import { z } from 'zod';

export const PaymentMethods = [
  'card', // debit card with Checkout
  'regular-bank', // bank transfer with SEPA,
  'apple-pay', // Apple Pay deposit with Checkout
  'sepa-direct-debit', // sepa direct debit with Checkout
] as const;

export const ZodPaymentMethod = z.enum(PaymentMethods);

export type PaymentMethod = z.infer<typeof ZodPaymentMethod>;

const B2BPaymentMethods = [
  'regular-bank', // bank transfer with SEPA,
  'sepa-direct-debit', // sepa direct debit with Checkout,
  'card', // card with Checkout,
  'apple-pay', // Apple Pay deposit with Checkout,
] as const;

export const ZodB2BPaymentMethod = z.enum(B2BPaymentMethods);

export type B2BPaymentMethod = z.infer<typeof ZodB2BPaymentMethod>;
